import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import ExamReAttemptModal from '@/components/common/examReAttemptModal/examReAttemptModal';
import { findCourseById, oldPaymentGatewaysToNewOne } from '@/utils';
import { reattemptExamApiCall } from '@/services/api';
import { toast } from 'sonner';
import { examType } from '@/pages/dashboard/constants';

import GreenFilledCircleTick from '@/assets/icons/greenTickInCircle.png'
import RedFilledCross from "@/assets/icons/redFilledCross.png";

import LightGreenFilledCircleTick from '@/assets/icons/lightGreenTickInCircle.png'
import LightRedFilledCross from "@/assets/icons/lightRedFilledCross.png";

import './style.css'
import { themes } from '@/constants/colors_v2';

export default function ExamUnLockCard(props: any) {
    const { timeline, common, dashboard } = useLocalTranslation();
    const navigate = useNavigate();
    const {
        isExamUnLockCardMain,
        unlockedORFailedEmu
    } = props
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
   
    const [unlockedORFailed, setUnlockedORFailed] = useState("")
    const [unlockedORFailedIcon, setUnlockedORFailedIcon] = useState<any>(null)

    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const [isActionBtnOfExamReAttemptModalLoading, setIsActionBtnOfExamReAttemptModalLoading] = useState(false)

    const currentExamType = examType.exam

    useEffect(() => {
        handleExamUnLockCardMain()
    }, [timelineDetails])


    const handleExamUnLockCardMain = () => {
        const isExamUnLockCardMain_ = isExamUnLockCardMain(timelineDetails)
        setUnlockedORFailed(isExamUnLockCardMain_)
        if (isExamUnLockCardMain_ === unlockedORFailedEmu.unlocked) {
            if(currentTheme === themes.dark){
                setUnlockedORFailedIcon(LightGreenFilledCircleTick)
            } else {
                setUnlockedORFailedIcon(GreenFilledCircleTick)
            }
        }
        else if (isExamUnLockCardMain_ === unlockedORFailedEmu.failed) {
            if(currentTheme === themes.dark){
                setUnlockedORFailedIcon(LightRedFilledCross)
            } else {
                setUnlockedORFailedIcon(RedFilledCross)
            }
        }
        // setUnlockedORFailedIcon(RedFilledCross) // testing
    }

    
    const handleExamUnLockCardMainHeadingColor = () =>{
        const isExamUnLockCardMain_ = isExamUnLockCardMain(timelineDetails)
        if (isExamUnLockCardMain_ === unlockedORFailedEmu.unlocked) {
            if(currentTheme === themes.dark){
                return "var(--green-color)"
            } else {
                return "var(--green-color5)"
            }
        }
        else if (isExamUnLockCardMain_ === unlockedORFailedEmu.failed) {
            if(currentTheme === themes.dark){
                return "var(--red-color12)"
            } else {
                return "var(--red-color13)"
            }
        }
    }


    const handleAction = () => {
        // console.log('examRedirect to exam', timelineDetails, unlockedORFailed)
        if (unlockedORFailed === unlockedORFailedEmu.failed) {
            handleOpenModal()
        } else {
            handleJustRedirectToExam()
        }
    }



    const handleOpenModal = () => {
        setShowModal(true)
    };

    const handleCloseModal = (status: string) => {        
        if (status === "ok") {
            if (timelineDetails.examAttempts >= 2) {
                setShowModal(false)
                handlePaymentForReAttempt()
                // console.log("pay then redirect exam")
            } else {
                handleReattemptExamApiCall(timelineDetails.purchaseId)
            }
        } else {
            setShowModal(false)
        }
    }


    const handlePaymentForReAttempt = () => {
        // debugger
        if (timelineDetails) {
            const examReAttemptCost = 200
            let gstRate = 18;
            if (timelineDetails.orderDetails.paymentGateway === "stripe") {
                gstRate = 9;
            }
            const gst = (examReAttemptCost * gstRate) / 100
            const subTotal = examReAttemptCost - gst

            // debugger
            let useParentDocumentId = timelineDetails.orderDetails._id
            if (!timelineDetails.orderDetails.isParent && timelineDetails.orderDetails.parentDocumentId) {
                useParentDocumentId = timelineDetails.orderDetails.parentDocumentId
            }
            // const currentCourseObj = findCourseById(timelineDetails.orderDetails.courses, timelineDetails.courseId)

            const tentativeOrder: any = {
                purchaseId: timelineDetails.purchaseId,
                orderType: 'examReattempt',
                paymentStructure: 'full',
                paymentStatus: 'pending',
                totalInstallments: 0,
                paidInstallments: 0,
                isParent: false,
                parentOrderId: timelineDetails.orderDetails.orderId,
                parentDocumentId: useParentDocumentId.toString(),
                installmentNumber: 0,
                offerDiscountInNumbers: 0,
                offerDiscountInPercentage: 0,
                couponDiscountInNumbers: 0,
                couponDiscountInPercentage: 0,
                gatewayDiscountPercentage: 0,
                gatewayDiscountInNumber: 0,
                originalAmount: Math.round(examReAttemptCost), // total amount
                grandTotal: Math.round(examReAttemptCost), // after discount
                netTotal: Math.round(examReAttemptCost), // same as grand
                GST: Math.round(gst), // 18 % netTotal ... stripe 9%
                subTotal: Math.round(subTotal), // after gst
                continent: timelineDetails.orderDetails.courses[0].pricingPlan.prices.continent,
                countryName: timelineDetails.orderDetails.courses[0].pricingPlan.prices.countryName,
                currencySymbol: timelineDetails.orderDetails.courses[0].pricingPlan.prices.symbol,
                currencyCode: timelineDetails.orderDetails.courses[0].pricingPlan.prices.code,
                installmentSchedule: null,
                installmentOption: null,
                courses: timelineDetails.orderDetails.courses, // check : send course OR course
                coursesMnemonic: timelineDetails.orderDetails.coursesMnemonic
            }

            // console.log('installmentDetails :', tentativeOrder, timelineDetails.orderDetails.paymentGateway)
            navigate('/payment', {
                state: {
                    tentativeOrder: tentativeOrder,
                    paymentGateway: oldPaymentGatewaysToNewOne(timelineDetails.orderDetails.paymentGateway),
                },
            });
        } else {
            alert('Issue in payment, please refresh and try again')
        }
    }


    const handleReattemptExamApiCall = async (purchaseId: any) => {
        toast.success("enter")
        setIsActionBtnOfExamReAttemptModalLoading(true)
        const payload = {
            purchaseId: purchaseId
        }
        const reattemptExamApiCallStatus = await reattemptExamApiCall(payload, currentExamType)
        if (reattemptExamApiCallStatus.status) {
            setIsActionBtnOfExamReAttemptModalLoading(false)
            setShowModal(false)
            handleJustRedirectToExam()
        } else {
            toast.error("Issue with re attempting the exam please refresh the page and try again")
            setIsActionBtnOfExamReAttemptModalLoading(false)
            setShowModal(false)
        }
    }


    const handleJustRedirectToExam = () => {
        navigate('/exam', {
            state: {
                // courseId: examType === "Test" ? examData.testExamId : examData.courseId,
                courseId: timelineDetails.courseId,
                purchaseId: timelineDetails.purchaseId,
                examType : currentExamType
            },
        });
    }

    return (
        <>
            <div className="examUnLockCardMain rounded-[7px] py-[15px] px-[17px]">
                <div className='flex items-center mb-[8px]'>
                    <img
                        className='w-[17px] h-[17px] mr-[6px]'
                        src={unlockedORFailedIcon} alt='greenFilledCircleTick' />
                    <p
                        // style={{
                        //     color: unlockedORFailed === unlockedORFailedEmu.unlocked ? "#FF0000" : "#FF0000"
                        // }}
                        style = {{
                            color : handleExamUnLockCardMainHeadingColor()
                        }}
                        className='font-bold text-[15px]'>
                        {/* {timeline.examUnLockCard.p1} */}
                        {unlockedORFailed === unlockedORFailedEmu.unlocked
                            ? timeline.examUnLockCard.p1 : timeline.examUnLockCard.p3}
                    </p>
                </div>
                <p className='text-[15px] mb-[8px]'>
                    {/* {timeline.examUnLockCard.p2} */}
                    {unlockedORFailed === unlockedORFailedEmu.unlocked
                        ? timeline.examUnLockCard.p2 : timeline.examUnLockCard.p4}
                </p>

                <button
                    onClick={() => handleAction()}
                    className='w-[100%] font-semibold cursor-pointer py-[6px] bg-[#1573FE] text-white rounded-[5px] text-[14px]'>
                    {/* {common.statusText.startExam} */}
                    {unlockedORFailed === unlockedORFailedEmu.unlocked
                        ? common.statusText.startExam : common.statusText.reattemptExam}
                </button>
            </div>


            <ExamReAttemptModal
                show={showModal}
                handleClose={handleCloseModal}
                title={dashboard.evaluateSection.exam.notice}
                examAttempts={timelineDetails.examAttempts}
                actionBtnLoading={isActionBtnOfExamReAttemptModalLoading}
            />

        </>
    );
}
